//const cloudfrontHome = " https://dwvzzl6nfv2mx.cloudfront.net/";
//const beyonddreamsHome = cloudfrontHome + "BeyondDreams/";
const beyonddreamsHome = "https://beyonddreamsassets.explorug.online/1/assets/";
export const pages = [
  beyonddreamsHome + "magazine-pages/01 - 1.jpg",
  beyonddreamsHome + "magazine-pages/01 - 1.jpg",
  beyonddreamsHome + "magazine-pages/01 - 2.jpg",
  beyonddreamsHome + "magazine-pages/02 - 1.jpg",
  beyonddreamsHome + "magazine-pages/02 - 02.jpg",
  beyonddreamsHome + "magazine-pages/03 - 1.jpg",
  beyonddreamsHome + "magazine-pages/03 - 2.jpg",
  beyonddreamsHome + "magazine-pages/04 - 1.jpg",
  beyonddreamsHome + "magazine-pages/04 - 2.jpg",
  beyonddreamsHome + "magazine-pages/05 - 01.jpg",
  beyonddreamsHome + "magazine-pages/05 - 02.jpg",
  beyonddreamsHome + "magazine-pages/06 - 01.jpg",
  beyonddreamsHome + "magazine-pages/06 - 02.jpg",
  beyonddreamsHome + "magazine-pages/07 - 1.jpg",
  beyonddreamsHome + "magazine-pages/07 - 2.jpg",
  beyonddreamsHome + "magazine-pages/08 - 1.jpg",
  beyonddreamsHome + "magazine-pages/08 - 2.jpg",
  beyonddreamsHome + "magazine-pages/09 - 1.jpg",
  beyonddreamsHome + "magazine-pages/09 - 2.jpg",
  beyonddreamsHome + "magazine-pages/10 - 1.jpg",
  beyonddreamsHome + "magazine-pages/10 - 02.jpg",
  beyonddreamsHome + "magazine-pages/11 - 1.jpg",
  beyonddreamsHome + "magazine-pages/11 - 02.jpg",
  beyonddreamsHome + "magazine-pages/12 - 1.jpg",
  beyonddreamsHome + "magazine-pages/12 - 2.jpg",
  beyonddreamsHome + "magazine-pages/13 - 11.jpg",
  beyonddreamsHome + "magazine-pages/13 - 12.jpg",
  beyonddreamsHome + "magazine-pages/14 - 1.jpg",
  beyonddreamsHome + "magazine-pages/14 - 2.jpg",
  beyonddreamsHome + "magazine-pages/15 - 1.jpg",
  beyonddreamsHome + "magazine-pages/15 - 2.jpg",
];

export const thumbdata = [
  beyonddreamsHome + "thumbs1/thumb-0.jpg",
  beyonddreamsHome + "thumbs1/thumb-1.jpg",
  beyonddreamsHome + "thumbs1/thumb-2.jpg",
  beyonddreamsHome + "thumbs1/thumb-3.jpg",
  beyonddreamsHome + "thumbs1/thumb-4.jpg",
  beyonddreamsHome + "thumbs1/thumb-5.jpg",
  beyonddreamsHome + "thumbs1/thumb-6.jpg",
  beyonddreamsHome + "thumbs1/thumb-7.jpg",
  beyonddreamsHome + "thumbs1/thumb-8.jpg",
  beyonddreamsHome + "thumbs1/thumb-9.jpg",
  beyonddreamsHome + "thumbs1/thumb-10.jpg",
  beyonddreamsHome + "thumbs1/thumb-11.jpg",
  beyonddreamsHome + "thumbs1/thumb-12.jpg",
  beyonddreamsHome + "thumbs1/thumb-13.jpg",
  beyonddreamsHome + "thumbs1/thumb-14.jpg",
  beyonddreamsHome + "thumbs1/thumb-15.jpg",
];

export const chevronsrc = [
  " ./magazine/icons/toleft.svg",
  " ./magazine/icons/toright.svg",

];

export const paneltogglesrc = [
  " ./magazine/icons/hidethumbpanel.svg",
  " ./magazine/icons/showthumbpanel.svg",

];

export const zoombtnsrc = [
  " ./magazine/icons/zoom-in.svg",
  " ./magazine/icons/zoom-out.svg",

];

export const fullscreenbtnsrc = [
  " ./magazine/icons/enter-fullscreen.svg",
  " ./magazine/icons/exit-fullscreen.svg",

];

export const magbase = beyonddreamsHome + "base.png";

export const links = [
  [{ page: 3, top: "30.7%", left: "75.3%", width: "21.4%", height: "5.8%", link: "https://alternative.com.np/en-us/augmented-rug-projection.php", action:"AugmentedRugProjection" }],
  [{ page: 5, top: "44%", left: "25.5%", width: "15.5%", height: "14.6%", link: "https://explor.ug/social", action:"FacebookSocialPost" }],
  [{ page: 6, top: "21.7%", left: "77%", width: "19.6%", height: "5.7%", link: "https://v3.explorug.com/beyonddreamsapp/", action:"MyRoomIceBreaker", redirectsession:true }],
  [
    { page: 7, top: "72.7%", left: "2.45%", width: "18.25%", height: "3%", link: "https://www.explorug.com/matchmycolors", action:"MatchMyColors" },
    // { top: "59%", left: "16%", width: "23%", height: "3%", link: "/magazine/1-1.png", download: "Image.jpg" }
  ],

  [{ page: 8, top: "21%", left: "14.6%", width: "13.2%", height: "5.7%", link: "https://beyonddreamsassets.explorug.online/1/assets/Pangmyck-closeup.jpg", self: true, action:"PangmyckCloseup" }],
  [{ page: 9, top: "40%", left: "-8%", width: "60%", height: "72%",rotate:"39deg", link: "https://beyonddreams.explorug.com/virtualphotostudio", action:"VirtualPhotoStudio" }],
  [{ page: 9, top: "64%", left: "50%", width: "39%", height: "36.1%", link: "https://beyonddreams.explorug.com/virtualphotostudio", action:"VirtualPhotoStudio" }],

  [{ page: 10, top: "6.4%", left: "33.2%", width: "6%", height: "9%",rotate:"28deg", link: "https://explor.ug/seashore", action:"VirtualPhotoStudio" }],
  [{ page: 10, top: "68.6%", left: "81.4%", width: "16%", height: "2.1%", link: "https://explor.ug/seashore", action:"Seashore" }],
  [{ page: 11, top: "37%", left: "60.5%", width: "6%", height: "10.7%", link: "https://explor.ug/Anteliss", action:"Anteliss" }],
  [{ page: 12, top: "57.5%", left: "53.2%", width: "10%", height: "13%",rotate:"32deg", link: "https://explor.ug/Kabavic", action:"Kabavic" }],
  [
    { page: 14, top: "90%", left: "2.5%", width: "16.2%", height: "5.7%", link: "https://explor.ug/stripe", action:"Stripe" },
  ],
  [{ page: 15, top: "25%", left: "31%", width: "16%", height: "5.6%", link: "mailto:shree@explorug.net", action:"MailToShree" }],
  [{ page: 15, top: "49%", left: "31%", width: "16%", height: "5.6%", link: "mailto:prabal@explorug.net", action:"MailToPrabal" }],
  [{ page: 15, top: "74%", left: "31%", width: "16%", height: "5.6%", link: "mailto:archana@explorug.net", action:"MailToArchana" }],
  [{ page: 15, top: "13%", left: "60%", width: "16%", height: "5.6%", link: "mailto:jyoti@explorug.net", action:"MailToJyoti" }],
  [{ page: 15, top: "39%", left: "60%", width: "16%", height: "5.6%", link: "mailto:padma@explorug.net", action:"MailToPadma" }],
  [{ page: 15, top: "62%", left: "60%", width: "16%", height: "5.6%", link: "mailto:pooja@explorug.net", action:"MailToPooja" }],
  [{ page: 15, top: "85%", left: "72.5%", width: "16%", height: "5.6%", link: "mailto:macc@theruggist.com", action:"MailToTheRuggist" }],

];


export const rugsharehomelink = "https://explorug.com/go/";
const mag = "https://beyonddreamsassets.explorug.online/1/assets/cinematic";
export const cinematicimages = [
  { color: "rgba(255, 0, 0, 0.7)", name: "Anteliss", link: "anteliss", qr: `${mag}/Anteliss/qr1.png`, imgsrc: `${mag}/Anteliss/Anteliss.rendered.jpg`, action:`AntelissRendered` },
  { color: "rgba(255, 0, 0, 0.7)", name: "Anteliss", link: "antelissr", qr: `${mag}/Anteliss/qr2.png`, imgsrc: `${mag}/Anteliss/Anteliss in Wall Hanging C.jpg`, action:`AntelissWallHanging` },
  { color: "rgba(255, 0, 0, 0.7)", name: "Kabavic", link: "kabavic", qr: `${mag}/Kabavic/qr1.png`, imgsrc: `${mag}/Kabavic/Kabavic.rendered.jpg`, action:`KabavicRendered` },
  { color: "rgba(255, 0, 0, 0.7)", name: "Kabavic", link: "kabavicr", qr: `${mag}/Kabavic/qr1.png`, imgsrc: `${mag}/Kabavic/Kabavic in Bedroom Plutet B2.jpg`, action:`KabavicBedroomPlutet` },
  { color: "rgba(255, 0, 0, 0.7)", name: "Wytics Isock", link: "wyticsisock", qr: `${mag}/Wytics Isock/qr1.png`, imgsrc: `${mag}/Wytics Isock/Wytics Isock.rendered.jpg`, action:`WyticsIsockRendered` },
  { color: "rgba(255, 0, 0, 0.7)", name: "Wytics Isock", link: "wyticsisockr", qr: `${mag}/Wytics Isock/qr1.png`, imgsrc: `${mag}/Wytics Isock/Wytics Isock in Reading Nook Stellatism.jpg`, action:`WyticsIsockReadingNookStellatism` },
];